import React, { useMemo } from 'react';

import { CartButton } from '@r1-frontend/entities/Layout/Header/commonComponents/CartButton';
import { LoginButton } from '@r1-frontend/entities/Layout/Header/commonComponents/LoginButton';
import
    CommonMobileHeader, {
    ICommonActions,
} from '@r1-frontend/entities/Layout/Header/mobile/components/CommonMobileHeader';
import BurgerView from '@r1-frontend/entities/Layout/Header/mobile/components/ConnectionAndLoginActions/BurgerView';
import MainView from '@r1-frontend/entities/Layout/Header/mobile/components/ConnectionAndLoginActions/MainView';
import { IUnauthHeaderProps } from '@r1-frontend/entities/Layout/Header/types';

const UnauthMobileHeader = ({
    onBecomeClientHandler,
    referrerPath,
    ...props
}: IUnauthHeaderProps): JSX.Element => {
    const CommonActions: ICommonActions = useMemo(() => {
        const Actions = <>
            <CartButton/>
            <LoginButton/>
            <MainView onOpenBecomeClientPopup={onBecomeClientHandler}/>
        </>;

        const ActionsInBurger = (_props: { closeHandler?: () => void }): JSX.Element => {
            return <BurgerView
                onOpenBecomeClientPopup={onBecomeClientHandler}
                referrerPath={referrerPath}
                {..._props}
            />;
        };

        return { Actions, ActionsInBurger };
    }, [onBecomeClientHandler, referrerPath]);

    return (
        <CommonMobileHeader
            {...props}
            CommonActions={CommonActions}
            isAuth={false}
        />
    );
};

export default UnauthMobileHeader;
